import React from 'react'
import clsx from 'clsx'

import DoneSVG from '../../../svg/DoneSVG'

const FormCheckbox = ({ id, checked, setChecked, isFormSubmitted, label }) => {
  return (
    <div className="relative max-w-max mb-1">
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={(e) => setChecked(e.target.checked)}
        className="hidden"
      />
      <label
        htmlFor={id}
        className="pl-7 block leading-tight font-light text-sm taller:text-base cursor-pointer"
      >
        {label || 'I hereby accept that...'}
        <span
          className={clsx(
            'absolute top-[calc(50%-10px)] left-0 w-[20px] h-[20px] border-2 rounded',
            {
              'border-bright-blue': (!isFormSubmitted && !checked) || checked,
              'border-red bg-red/10': isFormSubmitted && !checked,
            }
          )}
        />
        {checked && (
          <DoneSVG
            styles="absolute top-[calc(50%-8px)] left-[2px]"
            allowLightMode={false}
          />
        )}
      </label>
    </div>
  )
}

export default FormCheckbox
